// Formatēšana un mazi palīgi (latviešu decimālais komats).

export const clamp = (v: number, a: number, b: number) => Math.max(a, Math.min(b, v));
export const mean = (a: number[]) => (a.length ? a.reduce((s, x) => s + x, 0) / a.length : 0);
export const stdev = (a: number[]) => {
  const m = mean(a);
  return Math.sqrt(mean(a.map((x) => (x - m) * (x - m))));
};
export const uniq = <T,>(a: T[]) => Array.from(new Set(a));
export const round = (v: number, d = 2) => Math.round(v * 10 ** d) / 10 ** d;

/** 5 → "5", 5.26 → "5,3" */
export const fmt = (v: number) => {
  const r = Math.round(v * 10) / 10;
  return Number.isInteger(r) ? String(r) : r.toFixed(1).replace('.', ',');
};
/** 0.25 → "0,25" */
export const fmt2 = (v: number) => String(Math.round(v * 100) / 100).replace('.', ',');
export const sgn = (x: number) => (x >= 0 ? '+' : '−') + fmt(Math.abs(x));
export const sgn2 = (x: number) => (x >= 0 ? '+' : '−') + fmt2(Math.abs(x));
export const sgnR = (x: number) => (x >= 0 ? '+' : '−') + Math.abs(Math.round(x));
export const pctTxt = (x: number) => Math.round(x) + '%';
/** Enerģija vienībās: 72 → "72 v." */
export const euTxt = (x: number) => Math.round(x) + ' v.';
/** Enerģijas izmaiņa vienībās ar zīmi: −15 → "−15 v." */
export const sgnEu = (x: number) => sgnR(x) + ' v.';
export const pad = (n: number) => String(n).padStart(2, '0');
export const hhmm = (m: number) => pad(Math.floor(m / 60)) + ':' + pad(m % 60);

export const fmtDate = (ts: number, time = false) => {
  const d = new Date(ts);
  return (
    pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
    (time ? ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) : '')
  );
};
export const fmtStamp = (ts: number) => {
  const d = new Date(ts);
  return d.toDateString() === new Date().toDateString()
    ? 'šodien ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
    : fmtDate(ts, true);
};

/** Vērtības 0–10 krāsa: sarkans → dzintars → zaļš. */
export function heat(v: number) {
  const t = clamp(v, 0, 10);
  const h = t <= 5 ? 6 + (t / 5) * 32 : 38 + ((t - 5) / 5) * 104;
  return 'hsl(' + h.toFixed(0) + ' 65% 47%)';
}
/** Baterijas krāsa pēc piepildījuma (% no ietilpības). */
export const eColor = (pct: number) => heat(pct / 10);
/** Statuss pēc piepildījuma (% no ietilpības). */
export const eStatus = (L: number) =>
  L >= 70 ? 'Pilna enerģijas' : L >= 45 ? 'Normāls līmenis' : L >= 20 ? 'Zems — vajag atpūtu' : 'Kritiski zems';

const hexRgb = (h: string) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(h || '');
  const n = m ? parseInt(m[1], 16) : 0x7d7466;
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
/** Sajauc krāsu ar baltu (white=true) vai melnu. */
export const mixTo = (hex: string, white: boolean, t: number) =>
  'rgb(' + hexRgb(hex).map((v) => Math.round(v + ((white ? 255 : 0) - v) * t)).join(',') + ')';

export const isHexColor = (s: unknown): s is string => typeof s === 'string' && /^#[0-9a-f]{6}$/i.test(s);
